export const truncateAddress = (address, maxLength = 70) => {
  if (address.length > maxLength) {
    return address.substring(0, maxLength) + "...";
  }
  return address;
};
